import { OverAllEvaluationResult } from '../../redux/Slices/InterviewSlice/types';

import ShimmerAmination from './ShimmerAnimation';

const OverallPerformance = ({
  overall
}: {
  overall: OverAllEvaluationResult;
}) => {
  return (
    <div className='overall-performance relative mb-10 overflow-hidden rounded-xl bg-[linear-gradient(135deg,#667eea_0%,#764ba2_100%)] p-2 text-center text-white md:p-8'>
      <div className='relative z-10 text-center'>
        <div className='mb-4 inline-block rounded-full border border-white/30 bg-white/20 px-6 py-3 backdrop-blur-sm'>
          <span className='text-lg font-semibold'>{overall?.overallLevel}</span>
        </div>
        <h2 className='mb-3 text-xl font-bold md:text-3xl'>
          {overall?.overallTitle}
        </h2>
        <p className='mb-6 text-base opacity-90 md:text-lg'>
          {overall?.overallInterpretation}
        </p>
        <div className='rounded-lg border-l-4 border-white/50 bg-white/15 p-5 backdrop-blur-sm'>
          <p className='text-base'>{overall?.overallFeedback}</p>
        </div>
      </div>

      <ShimmerAmination />
    </div>
  );
};

export default OverallPerformance;
